/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * corev2 platform admins
 * Platform-admin accounts on corev2. The browser sends the HttpOnly cookie token. Headers x-gbooking-userid and x-gbooking-token are accepted when the cookie is absent.

 * OpenAPI spec version: 0.1.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"
import { customFetch } from "../../custom-corev2-client"
import type {
	PlatformAdminCreateRequest,
	PlatformAdminCreateResponse,
	PlatformAdminList,
	PlatformAdminUpdateRequest,
	PlatformAdminUpdateResponse,
} from ".././types/platform-admins"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary List platform accounts except the caller
 */
export type PlatformAdminslistPlatformAdminsResponse200 = {
	data: PlatformAdminList
	status: 200
}

export type PlatformAdminslistPlatformAdminsResponseSuccess =
	PlatformAdminslistPlatformAdminsResponse200 & {
		headers: Headers
	}

export type PlatformAdminslistPlatformAdminsResponse =
	PlatformAdminslistPlatformAdminsResponseSuccess

export const getPlatformAdminslistPlatformAdminsUrl = () => {
	return `/api/platform-admins`
}

export const PlatformAdminslistPlatformAdmins = async (
	options?: RequestInit,
): Promise<PlatformAdminslistPlatformAdminsResponse> => {
	return customFetch<PlatformAdminslistPlatformAdminsResponse>(
		getPlatformAdminslistPlatformAdminsUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getPlatformAdminslistPlatformAdminsQueryKey = () => {
	return [`/api/platform-admins`] as const
}

export const getPlatformAdminslistPlatformAdminsQueryOptions = <
	TData = Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof customFetch>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getPlatformAdminslistPlatformAdminsQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>
	> = ({ signal }) =>
		PlatformAdminslistPlatformAdmins({ signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		refetchOnMount: false,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PlatformAdminslistPlatformAdminsQueryResult = NonNullable<
	Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>
>
export type PlatformAdminslistPlatformAdminsQueryError = unknown

export function usePlatformAdminslistPlatformAdmins<
	TData = Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
					TError,
					Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function usePlatformAdminslistPlatformAdmins<
	TData = Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
					TError,
					Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function usePlatformAdminslistPlatformAdmins<
	TData = Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
/**
 * @summary List platform accounts except the caller
 */

export function usePlatformAdminslistPlatformAdmins<
	TData = Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof PlatformAdminslistPlatformAdmins>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getPlatformAdminslistPlatformAdminsQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return { ...query, queryKey: queryOptions.queryKey }
}

/**
 * @summary Create an account whose only role is platform_access
 */
export type PlatformAdminscreatePlatformAdminResponse200 = {
	data: PlatformAdminCreateResponse
	status: 200
}

export type PlatformAdminscreatePlatformAdminResponse201 = {
	data: PlatformAdminCreateResponse
	status: 201
}

export type PlatformAdminscreatePlatformAdminResponseSuccess = (
	| PlatformAdminscreatePlatformAdminResponse200
	| PlatformAdminscreatePlatformAdminResponse201
) & {
	headers: Headers
}

export type PlatformAdminscreatePlatformAdminResponse =
	PlatformAdminscreatePlatformAdminResponseSuccess

export const getPlatformAdminscreatePlatformAdminUrl = () => {
	return `/api/platform-admins`
}

export const PlatformAdminscreatePlatformAdmin = async (
	platformAdminCreateRequest: PlatformAdminCreateRequest,
	options?: RequestInit,
): Promise<PlatformAdminscreatePlatformAdminResponse> => {
	return customFetch<PlatformAdminscreatePlatformAdminResponse>(
		getPlatformAdminscreatePlatformAdminUrl(),
		{
			...options,
			method: "POST",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(platformAdminCreateRequest),
		},
	)
}

export const getPlatformAdminscreatePlatformAdminMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>,
		TError,
		{ data: PlatformAdminCreateRequest },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>,
	TError,
	{ data: PlatformAdminCreateRequest },
	TContext
> => {
	const mutationKey = ["platformAdminscreatePlatformAdmin"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>,
		{ data: PlatformAdminCreateRequest }
	> = (props) => {
		const { data } = props ?? {}

		return PlatformAdminscreatePlatformAdmin(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type PlatformAdminscreatePlatformAdminMutationResult = NonNullable<
	Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>
>
export type PlatformAdminscreatePlatformAdminMutationBody =
	PlatformAdminCreateRequest
export type PlatformAdminscreatePlatformAdminMutationError = unknown

/**
 * @summary Create an account whose only role is platform_access
 */
export const usePlatformAdminscreatePlatformAdmin = <
	TError = unknown,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>,
			TError,
			{ data: PlatformAdminCreateRequest },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof PlatformAdminscreatePlatformAdmin>>,
	TError,
	{ data: PlatformAdminCreateRequest },
	TContext
> => {
	return useMutation(
		getPlatformAdminscreatePlatformAdminMutationOptions(options),
		queryClient,
	)
}
/**
 * @summary Change name, email, or open/close platform_access (disabled on ACL)
 */
export type PlatformAdminsupdatePlatformAdminResponse200 = {
	data: PlatformAdminUpdateResponse
	status: 200
}

export type PlatformAdminsupdatePlatformAdminResponseSuccess =
	PlatformAdminsupdatePlatformAdminResponse200 & {
		headers: Headers
	}

export type PlatformAdminsupdatePlatformAdminResponse =
	PlatformAdminsupdatePlatformAdminResponseSuccess

export const getPlatformAdminsupdatePlatformAdminUrl = (id: string) => {
	return `/api/platform-admins/${id}`
}

export const PlatformAdminsupdatePlatformAdmin = async (
	id: string,
	platformAdminUpdateRequest: PlatformAdminUpdateRequest,
	options?: RequestInit,
): Promise<PlatformAdminsupdatePlatformAdminResponse> => {
	return customFetch<PlatformAdminsupdatePlatformAdminResponse>(
		getPlatformAdminsupdatePlatformAdminUrl(id),
		{
			...options,
			method: "PATCH",
			headers: { "Content-Type": "application/json", ...options?.headers },
			body: JSON.stringify(platformAdminUpdateRequest),
		},
	)
}

export const getPlatformAdminsupdatePlatformAdminMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>,
		TError,
		{ id: string; data: PlatformAdminUpdateRequest },
		TContext
	>
	request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
	Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>,
	TError,
	{ id: string; data: PlatformAdminUpdateRequest },
	TContext
> => {
	const mutationKey = ["platformAdminsupdatePlatformAdmin"]
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>,
		{ id: string; data: PlatformAdminUpdateRequest }
	> = (props) => {
		const { id, data } = props ?? {}

		return PlatformAdminsupdatePlatformAdmin(id, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type PlatformAdminsupdatePlatformAdminMutationResult = NonNullable<
	Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>
>
export type PlatformAdminsupdatePlatformAdminMutationBody =
	PlatformAdminUpdateRequest
export type PlatformAdminsupdatePlatformAdminMutationError = unknown

/**
 * @summary Change name, email, or open/close platform_access (disabled on ACL)
 */
export const usePlatformAdminsupdatePlatformAdmin = <
	TError = unknown,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>,
			TError,
			{ id: string; data: PlatformAdminUpdateRequest },
			TContext
		>
		request?: SecondParameter<typeof customFetch>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof PlatformAdminsupdatePlatformAdmin>>,
	TError,
	{ id: string; data: PlatformAdminUpdateRequest },
	TContext
> => {
	return useMutation(
		getPlatformAdminsupdatePlatformAdminMutationOptions(options),
		queryClient,
	)
}
